<div style="padding: 0 10px">
  @for (item of items;track item) {
  <div class="centered">
    <ion-icon
      style="font-size: 20px"
      [class]="allValues[item].class"
      [name]="allValues[item].icon"
    ></ion-icon>
    <div style="margin-left: 2px">{{ allValues[item].label }}</div>
  </div>
  }
</div>
